import { useEffect, useRef, useState } from "react"
import { TextField, InputAdornment } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"

const defaultTimeout = 500

const SearchInput = ({
    initialValue,
    onChange,
    timeout = defaultTimeout,
    ...props
}: {
    initialValue: string
    onChange: Function
    timeout?: number
}) => {
    const [search, setSearch] = useState(initialValue || '')
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => onChange(search), timeout) 
    }, [search, onChange, timeout])

    return (
        <TextField
            fullWidth
            placeholder="Pesquisar contatos"
            size="small"
            value={search}
            onChange={({ target }) => setSearch(target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#bbb", fontSize: 19 }} />
                    </InputAdornment>
                ),
            }}
            sx={{
                mb: 1.5,
                flexShrink: 0,
                "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    bgcolor: "#fff",
                    "& fieldset": { borderColor: "#e0e0e0" },
                    "&:hover fieldset": { borderColor: "#bdbdbd" },
                    "&.Mui-focused fieldset": { borderColor: "rgb(70 171 227)" },
                },
                "& input": { fontSize: "0.86rem", color: "#333" },
                "& input::placeholder": { color: "#aaa", opacity: 1 },
            }}
            {...props}
        />
    )
}

export default SearchInput